<template>
  <div class="courseInfo" :data="datacourse">
    <div v-if="datacourse.length==0" class="noResultInfo">
      <p class="font_24_reg">{{$t('tabBar.noLesson')}}</p>
      <p class="font_24_reg">{{$t('tabBar.download')}}</p>
      <div class="flex_justify_center">
        <img src="../../assets/Download_App_Store.svg" style="margin-right: 20px;" />
        <img style="width: 120px;height: 40px" src="../../assets/tencent.png" />
      </div>
    </div>
    <div class="courslist" v-else>
      <div class="courseTitle" v-for="(item, i) in datacourse" :key="i">
        <h3 class="font_24_bold flex_center"><img :src="item.subject_img" />{{item.subjects_title}}</h3>
        <div class="flex_between nextT">
          <p class="font_16 nextLess">{{$t('course.nextLesson')}}: {{item.next_at}}</p>
          <button class="font_16 level">{{item.level_title}}</button>
        </div>
        <div class="lineHeigh">
          <div class="flex_center" v-for="(timeItem, j) in item.settingFormat"  :key="j">
            <p class="font_16">{{timeItem.weekday}}</p>
            <span class="dot"></span>
            <p class="font_16">{{timeItem.start_at}}</p>
          </div>
        </div>
        <div class="lineHeigh nextT">
          <div class="flex_center">
            <img :src="item.student_avatar">
            <p class="font_16">{{item.nickname}}</p>
          </div>
        </div>
        Not Started
        </button></div>
        <div class="flex_justify_end statusBtn"><button :class="item.status==0?'noStarted_full':(item.status==1?'pending_full':'completed_full')">
          {{item.status==0?$t('main.noStart'):(item.status==1?$t('main.inProgress'):(item.status==2?$t('main.completed'):(item.status==3?$t('main.cancel'):'')))}}
          </button></div>
      </div>
    </div>
  </div>
</template>
<script>
import { setStore, getStore, keys } from '@/store';
export default {
  props: {
    datacourse: Array,
    required: true
  },
}
</script>
<style lang="less" scoped>
.courseInfo{
  .noResultInfo{
    margin-top:80px;
    text-align: center;
    width:100%;
    p{
      margin-bottom:32px;
    }
  }
  .courslist{
    display: flex;
    flex-wrap: wrap;
    .courseTitle{
      width:360px;
      border-radius: 6px;
      margin:0 10px 10px 0;
      padding:45px 23px 23px;
      background: #FAFAFA;
      border: 2px solid rgba(165, 165, 165, 0.5);
      position: relative;
      &:nth-child(2n+0){
        margin-right:0;
      }
      h3{
        padding-bottom:15px;
        border-bottom: 1px solid rgba(165, 165, 165, 0.5);
        img{
          width:48px;
          height:48px;
          margin-right:10px;
        }
      }
      .typeStud{
        padding:16px 0;
        border-bottom:  1px solid #dadada;
      }
      .nextT{
        margin-top:10px;
      }
      .nextLess{
        padding: 6px;
        background: #FFD1C6;
      }
      .level{
        height: 36px;
        line-height: 36px;
        padding:0 10px;
        border:none;
        border-radius: 30px;
        background: #ffb800;
        color:#000;
      }
      .m24{
        margin-top:24px;
      }
      .lineHeigh{
        line-height: 24px;
        .dot{
          width:6px;
          height:6px;
          background: #6B7897;
          border-radius: 50%;
          margin:0 15px;
        }
        img{
          width:30px;
          height:30px;
          border-radius: 50%;
          margin-right:10px;
        }
      }
      .huo {
        font-size: 16px;
        font-family: Sofia Pro-Bold;
        font-weight: 700;
        text-decoration: underline;
        text-align: LEFT;
        color: #ff6440;
        cursor: pointer;
        margin-top:10px;
        display: flex;
        align-items: center;
      }
      .statusBtn{
        position: absolute;
        top:15px;
        right:15px;
      }
    }

  }

}
</style>



// WEBPACK FOOTER //
// src/components/views/course.vue